import { StyleSheet, Text, View } from 'react-native';

import { colors, fonts, fontSizes } from '@/constants/theme';

/**
 * Brand-canonical scaled "MP" watermark for dark hero cards (brand kit p.16).
 * Single source of truth so the Home, cashout, and refer heroes stay
 * pixel-identical — the cashout design contract requires the watermark match
 * home exactly, and this was previously copy-pasted (with drifting positions)
 * across HeroEarningsCard, confirm-styles, and the home balance hero.
 *
 * Place as the first child of a dark `<Card>` with `overflow: 'hidden'`.
 */
export function HeroWatermark() {
  return (
    // Decorative only — the scaled M/P is brand texture, not content, so it
    // stays out of the accessibility tree. Without this VoiceOver announces
    // a stray "MP" on every dark card it sits behind.
    <View
      style={styles.layer}
      pointerEvents="none"
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
    >
      <Text style={styles.mark}>MP</Text>
    </View>
  );
}

// Geometry is the home hero's (HeroEarningsCard) original values — the cashout
// design contract makes home the reference ("watermark matches home exactly").
const styles = StyleSheet.create({
  layer: {
    position: 'absolute',
    top: -40,
    right: -20,
  },
  mark: {
    fontFamily: fonts.numeric,
    fontSize: fontSizes.watermark,
    color: colors.watermarkOnDark,
    transform: [{ rotate: '-8deg' }],
  },
});
